import { Box, InputAdornment, Typography } from '@material-ui/core'
import TextField from '@mui/material/TextField'
import { useMemo } from 'react'
import { Button, IconButton } from '@mui/material'
import { SearchOutlined, ClearOutlined } from '@mui/icons-material'
import {
  getAssociatedTickets,
  linkInternalTicketsToFrontConversation,
} from '../api'
import { TicketCard } from '../components/TicketCard'
import config from '../../../config'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined'

export const FrontPluginLink = ({
  searchValue,
  setSearchValue,
  setShowHomePage,
  unlinkedInternalTickets,
  currentFrontTicket,
  setUnlinkedInternalTickets,
  setLinkedInternalTickets,
}) => {
  if (!unlinkedInternalTickets) {
    return <div>Loading...</div>
  }

  const checkedTickets = useMemo(() => {
    return unlinkedInternalTickets.reduce(
      (acc, ticket) => (ticket.isChecked ? acc + 1 : acc),
      0
    )
  }, [unlinkedInternalTickets])

  const handleCheckboxChange = (ticketId) => {
    setUnlinkedInternalTickets((prevTickets) =>
      prevTickets.map((ticket) =>
        ticket.id === ticketId
          ? { ...ticket, isChecked: !ticket.isChecked }
          : ticket
      )
    )
  }

  const linkTicket = () => {
    if (currentFrontTicket && unlinkedInternalTickets?.length > 0) {
      const selectedTickets = unlinkedInternalTickets.reduce((acc, ticket) => {
        const isDraftTicket = !ticket.stateName
        if (ticket.isChecked) {
          acc.push({ id: ticket.id, isDraftTicket })
        }
        return acc
      }, [])

      linkInternalTicketsToFrontConversation(currentFrontTicket.id, {
        tickets: selectedTickets,
        frontTicket: currentFrontTicket,
      })
        .then(() => {
          return getAssociatedTickets(currentFrontTicket.id)
        })
        .then((data) => {
          setLinkedInternalTickets(data)
        })
    }
    setShowHomePage(true)
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: '16px',
          position: 'sticky',
          top: 0,
          backgroundColor: 'white',
          padding: '5px 0',
          zIndex: 2,
        }}
      >
        <Button
          variant="text"
          onClick={() => setShowHomePage(true)}
          startIcon={<ArrowBackIosOutlinedIcon />}
        >
          Retour
        </Button>
        <TextField
          style={{ width: '100%' }}
          size={'small'}
          placeholder="Référence, ID, Titre"
          inputProps={{ 'aria-label': 'search' }}
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchValue && (
                  <>
                    <IconButton onClick={() => setSearchValue('')}>
                      <ClearOutlined />
                    </IconButton>
                  </>
                )}
                <IconButton disabled={true}>
                  <SearchOutlined />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {unlinkedInternalTickets?.length > 0 ? (
        unlinkedInternalTickets.map((ticket, index) => (
          <TicketCard
            key={ticket.id}
            ticket={ticket}
            isChecked={ticket.isChecked}
            handleCheckboxChange={handleCheckboxChange}
            isLastCard={index === unlinkedInternalTickets.length - 1}
          />
        ))
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            width: '100%',
            marginY: '20px',
          }}
        >
          <Typography variant="h6">Aucun ticket trouvé</Typography>
          <img
            src={`${config.PUBLIC_URL}/img/mandy_no-result.png`}
            style={{
              width: '120px',
            }}
          />
        </Box>
      )}

      {!!checkedTickets && (
        <Button
          size="large"
          variant="contained"
          color="primary"
          onClick={linkTicket}
          fullWidth
          sx={{
            position: 'sticky',
            bottom: 0,
            boxShadow: '0 0 0 5px white',
          }}
        >
          Lier {checkedTickets} ticket(s)
        </Button>
      )}
    </Box>
  )
}
